import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/allstar/layout"
import SectionHero from "../components/allstar/resource/badges/section-hero"
import SectionBody from "../components/allstar/resource/badges/section-body"
import { useYear } from "../context/YearContext"

const BadgesPage = props => {
  const { selectedYear } = useYear()
  return (
    <Layout location={props.location} title={"Badges"} isResourceSite>
      <SectionHero data={props.data} year={selectedYear} />
      <SectionBody data={props.data} />
    </Layout>
  )
}

export default BadgesPage

export const query = graphql`
  query badgesPage {
    allFile(filter: { relativeDirectory: { eq: "allstar/badges" } }) {
      edges {
        node {
          name
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
